<template>
  <div class='attention_to'>
    <h3>
        Attention To
        <edit-icon-btn @click='$refs[`modal`].show()' />
    </h3>
    <div>{{ order.attention_to }}</div>

    <b-modal
      ref='modal'
      :class='`edit-attention-modal`'
      centered
      :title='`Edit Attention To`'
      size=md
      ok-title='Continue'
      ok-variant='primary'
      cancel-variant='medium'
      @ok='save_value'
      @show='reset_value'
      :busy='busy'
      >
      <b-row class='form-group-row'>
        <b-col cols=12>
          <b-form-group
            label='Attention To'
            :label-for='`attention_to`'
            >
              <b-form-input
                :id='`attention_to`'
                v-model='pending_value'
                />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';

import { mapState, mapMutations } from 'vuex';

export default {
  name: 'EditAttention',
  data () {
    return {
      pending_value: null,
      busy: false,
    }
  },
  computed: {

    ...mapState( 'order_details', [
      'order'
    ]),

    saved_value () {
      return _.get( this.order, 'attention_to', '' );
    },

  },
  methods: {

    ...mapMutations( 'order_details', [
      'set_order_prop',
    ]),

    reset_value () {
      this.pending_value = this.saved_value;
    },

    save_value ( e ) {
      e.preventDefault();
      this.busy = true;
      const busy_id = this.$jjToast({
        type: 'busy',
        title: 'Saving',
        content: 'Saving attention to',
      });
      axios.put( `orders/${ this.order.id }/attention`, { value: this.pending_value })
        .then( response => {
          this.set_order_prop({
            prop: 'attention_to',
            value: response.data.attention_to,
          });
          this.$refs['modal'].hide();
          this.$jjToast({
            type: 'success',
            title: 'Updated',
            content: 'Saved attention to',
          });
        })
        .catch( () => {
          this.$jjToast({
            type: 'error',
            title: 'Error',
            content: 'Failed to save attention to',
          });
        })
        .finally( () => {
          this.busy = false;
          this.$bvToast.hide( busy_id );
        });
    }

  },
}
</script>